export enum MyCsvColumnsEnum {
    name = 'Projektname',
    companyName = 'Firma',
    companyZip = 'Ort',
    requestedProductsTotalCount = 'Geräte',
    rolloutStart = 'Projektzeitraum von',
    rolloutEnd = 'Projektzeitraum bis',
    lastUpdateBy = 'Bearbeitet von',
    status = 'Projektstatus',
    statusDetails = 'Projektstatus Details',
    priceApprovalStatus = 'Projektpreis Genehmigungsstatus',
    priceApprovalComment = 'Genehmigungskommentar'
}
